import React from 'react';
import Button from '@mui/material/Button';

const SsoLoginButton = function SsoLoginButton({
  label,
  loginUrl,
  Icon,
  sx = {},
}) {
  return (
    <form action={loginUrl} method="post">
      <Button
        type="submit"
        variant="outlined"
        sx={{
          border: '2px solid #d6d6d6',
          color: 'greys.title',
          textTransform: 'none',
          borderRadius: '10px',
          '&:hover': {
            borderWidth: '2px',
          },
          ...sx,
        }}
        fullWidth
        size="medium"
      >
        <Icon />
        <span>{label}</span>
      </Button>
    </form>
  );
};

export default SsoLoginButton;
